import { PersonalizationService } from '@magnolia/template-annotations';

export default PersonalizationService;
